import React from 'react';

function AECapacityTable({ forecastData }) {
  if (!forecastData || !forecastData.base) {
    return null;
  }

  // Get forecast data for key months in 2025 and 2026
  const keyMonths = [
    '2025-06',
    '2025-12',
    '2026-06',
    '2026-12'
  ];

  const capacityData = keyMonths
    .map(month => {
      const dataPoint = forecastData.base.find(d => d.month === month);
      return dataPoint ? { month, ...dataPoint } : null;
    })
    .filter(d => d !== null);

  const formatMonth = (month) => {
    const [year, monthNum] = month.split('-');
    const date = new Date(year, parseInt(monthNum) - 1);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4">AE Capacity Utilization</h3>
      <p className="text-sm text-gray-500 mb-4">Base case capacity analysis</p>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b-2 border-gray-200">
              <th className="text-left py-2 px-2 font-semibold text-gray-700">Month</th>
              <th className="text-right py-2 px-2 font-semibold text-gray-700">SQOs</th>
              <th className="text-right py-2 px-2 font-semibold text-gray-700">Closed Won</th>
              <th className="text-right py-2 px-2 font-semibold text-gray-700">Pipeline</th>
            </tr>
          </thead>
          <tbody>
            {capacityData.map((data, idx) => {
              return (
                <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-2 px-2 font-medium">{formatMonth(data.month)}</td>
                  <td className="py-2 px-2 text-right">{data.sqos}</td>
                  <td className="py-2 px-2 text-right">{data.closedWon}</td>
                  <td className="py-2 px-2 text-right font-semibold">${(data.pipeline * 1).toFixed(1)}M</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="mt-4 p-4 bg-blue-50 rounded">
        <h4 className="text-sm font-semibold text-blue-900 mb-2">Metrics Notes:</h4>
        <ul className="text-xs text-blue-800 space-y-1">
          <li>• SQOs = Sales Qualified Opportunities</li>
          <li>• Closed Won = Deals expected to close</li>
          <li>• Pipeline = Projected opportunity value</li>
        </ul>
      </div>
    </div>
  );
}

export default AECapacityTable;
